import equal from 'fast-deep-equal';
import type { IColumn } from '../../types/IColumn';

export const areColumnsEqual = (columnArray1: IColumn[] = [], columnArray2: IColumn[] = []) => {
  const arr1 = columnArray1
    .map(({ cleanValue, getValue, formatter, ...fields }) => fields)
    .sort((a, b) => b.key.localeCompare(a.key));
  const arr2 = columnArray2
    .map(({ cleanValue, getValue, formatter, ...fields }) => fields)
    .sort((a, b) => b.key.localeCompare(a.key));
  return equal(arr1, arr2);
};
